import React, { Component } from 'react';
import { noop } from 'lodash';

class TextArea extends Component {
    constructor(props) {
        super(props);
        this.elementRef = React.createRef();
    }
    state = { focus: false };
    focus = () => {
        this.elementRef.current.focus();
    };
    _onChange = e => this.props.onChange(e.target.value, e.target.name);
    _onFocus = () => this.setState({ focus: true });
    _onBlur = () => this.setState({ focus: false });
    render() {
        return (
            <div className={`ckp-textarea ${this.props.className || ''} ${this.state.focus ? 'is-focussed' : ''}`}>
                {this.props.label ? <label className="ckp-textarea-label">{this.props.label}</label> : null}
                <textarea
                    maxLength={this.props.maxLength}
                    ref={this.elementRef}
                    disabled={this.props.disabled}
                    onBlur={this._onBlur}
                    onFocus={this._onFocus}
                    className="ckp-textarea-field"
                    name={this.props.name}
                    value={this.props.value}
                    onChange={this._onChange}
                    placeholder={this.props.placeholder}
                />
            </div>
        );
    }
}

TextArea.defaultProps = { onChange: noop };

export default TextArea;
